import React from 'react'
import { orderShippingType, printType } from '../../constants/orderType'
import logoList, { companyInfo } from '../../constants/logoList'
import moment from 'moment/moment'

const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth'
const BRAND = process.env.REACT_APP_BRAND || 'wlink'

const InvoiceHeader = ({ order, type }) => (
    <>
        <div className="invoice-header-container">
            <div className="invoice-header-logo">
                <img
                    src={logoList?.[CLIENT]?.PRINT_LOGO}
                    alt="logo"
                    className="invoice-header-logo-size"
                />
            </div>
            <div className="invoice-header-name">
                <h3>{companyInfo?.[BRAND]?.COMPANY_NAME}</h3>
                <br />
                <p>{companyInfo?.[BRAND]?.COMPANY_ADDRESS}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_ADDRESS_1}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_PHONE}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_WEB_URL}</p>
                <p>{companyInfo?.[BRAND]?.COMPANY_EMAIL}</p>
            </div>
            {(type === printType.INVOICE ||
                type === printType.PACKING_LIST) && (
                <div className="invoice-header-invoice-no">
                    <div>
                        <h2 style={{ textAlign: 'center' }}>
                            {type === printType.INVOICE
                                ? order?.memoOrder
                                    ? 'Memo'
                                    : 'Invoice'
                                : 'Packing List'}
                        </h2>
                    </div>
                    <br />
                    <div>
                        <table
                            className="invoice-header-top-table"
                            style={{ width: '100%' }}
                        >
                            <tbody>
                                <tr className="invoice-header-top-table">
                                    <td className="invoice-header-top-table">
                                        Date
                                    </td>
                                    <td className="invoice-header-top-table">
                                        {order?.invoiceDate}
                                    </td>
                                </tr>
                                <tr className="invoice-header-top-table">
                                    <td className="invoice-header-top-table">
                                        {order?.memoOrder ? '' : 'Invoice'}#
                                    </td>
                                    <td className="invoice-header-top-table">
                                        {order?.invoiceNumber}
                                    </td>
                                </tr>
                                {order?.salesRep && (
                                    <tr className="invoice-header-top-table">
                                        <td className="invoice-header-top-table">
                                            Sales Rep
                                        </td>
                                        <td className="invoice-header-top-table">
                                            {order?.salesRep}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {type === printType.QUOTATION && (
                <div className="invoice-header-invoice-no">
                    <div>
                        <h2 style={{ textAlign: 'center' }}>Quotation</h2>
                    </div>
                    <br />
                    <div>
                        <table
                            className="invoice-header-top-table"
                            style={{ width: '100%' }}
                        >
                            <tbody>
                                <tr className="invoice-header-top-table">
                                    <td className="invoice-header-top-table">
                                        Date
                                    </td>
                                    <td className="invoice-header-top-table">
                                        Quote#
                                    </td>
                                </tr>
                                <tr className="invoice-header-top-table">
                                    <td className="invoice-header-top-table">
                                        {moment(order?.createdAt).format(
                                            'YYYY-MM-DD'
                                        )}
                                    </td>
                                    <td className="invoice-header-top-table">
                                        {order?.draftNo}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
        <div className="invoice-to-container">
            <div className="invoice-to-item">
                <div>
                    {type === printType.INVOICE &&
                        !order?.memoOrder &&
                        'Invoice '}
                    {type === printType.QUOTATION && 'Quotation '}
                    To
                </div>
                <div className="invoice-to-details">
                    <p>{order?.company}</p>
                    <p>{order?.clientName}</p>
                    <p>
                        {order?.address}, {order?.addressLine2}
                    </p>
                    <p>
                        {order?.city}, {order?.province} {order?.postCode}
                    </p>
                    <p>T: {order?.phone}</p>
                    <p>PO#: {order?.poNumber}</p>
                </div>
            </div>
            {order?.shippingType === orderShippingType.SHIPPING && (
                <div className="invoice-to-item">
                    <div>Ship To</div>
                    <div className="invoice-to-details">
                        <p>
                            {order?.ordershippingaddress?.firstName}{' '}
                            {order?.ordershippingaddress?.lastName}
                        </p>
                        <p>
                            {order?.ordershippingaddress?.address},{' '}
                            {order?.ordershippingaddress?.address1}
                        </p>
                        <p>
                            {order?.ordershippingaddress?.city},{' '}
                            {order?.ordershippingaddress?.province}{' '}
                            {order?.ordershippingaddress?.postCode}
                        </p>
                        <p>T: {order?.ordershippingaddress?.phone}</p>
                    </div>
                </div>
            )}
        </div>
    </>
)

export default InvoiceHeader
